module.exports = "<ng-content *ngIf=\"sortField !== getCurrentSortField()\"></ng-content>\n";